export const RESET = 'MEDIAOBJECT_LIST_RESET';
export const SET_ITEMS = 'MEDIAOBJECT_LIST_SET_ITEMS';
export const SET_ERROR = 'MEDIAOBJECT_LIST_SET_ERROR';
export const SET_SELECT_ITEMS = 'MEDIAOBJECT_LIST_SET_SELECT_ITEMS';
export const SET_VIEW = 'MEDIAOBJECT_LIST_SET_VIEW';
export const TOGGLE_LOADING = 'MEDIAOBJECT_LIST_TOGGLE_LOADING';



// WEBPACK FOOTER //
// ./src/store/modules/mediaobject/list/mutation_types.js